let mvTl = gsap.timeline();
let bgSlide;
let humanSlide;

class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-humanSlide, .js-mvNone, .js-drawer, .js-mv').css({'opacity': '0'});

    // **************************************
    // MVアニメーション
    // **************************************

    let jsMvNewsInterval;

    let args = {
      loop:true,
      autoplay: { // 自動再生
        delay: 2500, // 1.5秒後に次のスライド
        disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
      },
      speed: 750,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
    }

    bgSlide = new Swiper('.js-bgSlide', {
      ...args
    });

    humanSlide = new Swiper('.js-humanSlide', {
      ...args
    });

    $('.mv-wrap path').addClass('is-anime');
    
    humanSlide.autoplay.stop();
    bgSlide.autoplay.stop();

    mvTl.to('.js-humanSlide', 1, {
      opacity: 1,
      delay: 3,
      onStart: () => {
        $('.js-h1 > div').addClass('is-active');
      },
      onComplete: () => {
        humanSlide.autoplay.start();
        bgSlide.autoplay.start();
      }
    })

    mvTl.to('.js-mv, .js-mvNone, .js-drawer', 0.75, {
      opacity: 1,
      onStart: () => {
        clearInterval(jsMvNewsInterval);

        jsMvNewsInterval = setInterval(() => {
          jsMvNews();
        }, 3000);
      },
    }, '-=0.5')

    
    // **************************************
    // MVニュース
    // **************************************

    $('.js-mvNews-arrow').click(function() {
      jsMvNews();
      clearInterval(jsMvNewsInterval);

      jsMvNewsInterval = setInterval(() => {
        jsMvNews();
      }, 3000);
    })

    function jsMvNews() {
      let nowActive = $('.js-news .is-active');
      nowActive.removeClass('is-active');
      nowActive.css({'transform': 'translateY(4rem)','opacity': '0'});

      setTimeout(() => {
        nowActive.css({'transform': 'translateY(-4rem)'});
      }, 300);

      $('.js-mvNews-arrow').css({'pointerEvents': 'none'});

      let nextActive;
      
      if($(this).hasClass('js-mvNews-next')) {
        nextActive = nowActive.next().length ? nowActive.next() : $('.js-news > div:first-of-type');
      } else {
        nextActive = nowActive.prev().length ? nowActive.prev() : $('.js-news > div:last-of-type');
      }
      nextActive.addClass('is-active');

      setTimeout(() => {
        $('.js-mvNews-arrow').css({'pointerEvents': 'auto'});
      }, 300);
    }
    
    // **************************************
    // MV背景
    // **************************************

    let trigger = ScrollTrigger.create({
      trigger: ".js-middle-trigger",
      start: "top top",
      end: "top top",
      onEnter: () => {
        $('.js-bgSlide, .js-humanSlideWrap').css({'opacity': '0'});
      },
      onEnterBack: () => {
        $('.js-bgSlide, .js-humanSlideWrap').css({'opacity': '1'});
      }
    })
    
    // **************************************
    // ATJを知る
    // **************************************

    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }

    let atjSwiperFlag = true;

    let atjSwiper01 = "";

    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          if(atjSwiperFlag === true) {
            atjSwiper01 = new Swiper('.atjSwiper01', {
              loop:true,
              autoplay: { // 自動再生
                delay: 4000, // 1.5秒後に次のスライド
                disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
              },
              speed: 700,
              effect: 'fade',
              fadeEffect: {
                crossFade: true
              },
              slideChangeTransitionStart: function () {
                this.autoplay.stop();
                this.autoplay.start();
              },
              touchEnd: function () {
                this.autoplay.stop();
                this.autoplay.start();
              },
            });
            const atjSwiper02 = new Swiper('.atjSwiper02', {
              loop:true,
              spaceBetween: 10,
              speed: 500,
              breakpoints: {
                768: {
                  spaceBetween: 4,
                },
              },
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
                renderFraction: function (currentClass, totalClass) {
                  return (
                    '<span class="' + currentClass + '"></span>' +
                    '<span class="border js-border"><span></span></span>' +
                    '<span class="' + totalClass + '"></span>'
                  );
                },
                formatFractionCurrent: function (number) {
                  let num = number % 3 === 0 ? '3' : String(number % 3); // 文字列に統一
                  return '0' + num; // 01, 02, 03 のように2桁表記
                },
                formatFractionTotal: function () {
                  return '03';
                }
              },
              on: {
                init: function () {
                  
                  setTimeout(() => {
                    const pagiNation = document.querySelector('.swiper-pagination');
                    pagiNation.classList.add('is-active');
                  }, 100);
                },
                slideChangeTransitionStart: function () {
                  const border = document.querySelector('.js-border span');
                  if (border) {
                    border.style.transitionTimingFunction = 'ease';
                    border.style.transitionDuration = '500ms';
                    border.style.transform = 'scaleX(0)';
                  }
                  atjSwiper01.autoplay.stop();
                  atjSwiper01.autoplay.start();
                },
                slideChangeTransitionEnd: function () {
                  const border = document.querySelector('.js-border span');
                  if (border) {
                    border.style.transitionTimingFunction = 'linear';
                    border.style.transitionDuration = '4000ms';
                    border.style.transform = 'scaleX(1)';
                  }
                },
                touchEnd: function () {
                  atjSwiper01.autoplay.stop();
                  atjSwiper01.autoplay.start();
                },
              }
            });
            atjSwiper01.controller.control = [atjSwiper02];
            atjSwiper02.controller.control = [atjSwiper01];

            atjSwiperFlag = false;
          }
        }
      });
    }, options);

    let swiperEl = document.querySelectorAll('.atjSwiper01');

    // .atjSwiper02 にホバーしたら atjSwiper01 の autoplay を停止
    $(".atjSwiper01, .atjSwiper02").hover(
      function () {
        atjSwiper01.autoplay.stop();
      },
      function () {
        atjSwiper01.slideNext();
        atjSwiper01.autoplay.start();
      }
    );

    swiperEl.forEach((e)=>{
      observerEnter.observe(e);
    });

    // **************************************
    // タブレット用 アスペクト比をチェックし、htmlタグにクラスを追加/削除する関数
    // **************************************
    function updateHtmlClass() {
      var aspectRatio = $(window).width() / $(window).height(); // ウィンドウの幅 ÷ 高さ でアスペクト比を取得
  
      if (aspectRatio <= 1.7) {
        $("html").addClass("tablet"); // 1.7以下なら .tablet クラスを追加
      } else {
        $("html").removeClass("tablet"); // 1.7を超えたら .tablet クラスを削除
      }
    }
  
    // ページ読み込み時に実行
    updateHtmlClass();
  
    // ウィンドウサイズ変更時に再チェック
    $(window).on("resize", updateHtmlClass);


    $(".js-view-opacity, .js-view-opacity-top").each(function() {
      const $element = $(this);

      // 元の内容を取得
      const originalContent = $element.html();

      // 新しい内容を <span> で囲んで生成
      const spanContent = `<div class="duplicate" style="width: 100%;">${originalContent}</div><div class="duplicate" style="width: 100%;">${originalContent}</div>`;

      // .js-view-opacity の要素に新しい内容を設定
      $element.html(spanContent);
    })

    gsap.to('.js-view', 
      {
        scrollTrigger: {
          trigger: '.js-view',
          start: 'top+=150px bottom',
          onEnter: (self) => {
            self.trigger.classList.add('is-active');
            gsap.to(self.trigger.querySelectorAll('.duplicate'), 1.5, {
              clipPath: "inset(0% 0% 0% 0%)",
              duration: 1.6,
              stagger: 0.2,
              ease:"cubic.inOut",
              onComplete: function(self) {
                $(this.targets()).css({'clipPath': 'none'});
              }
            });
          },
        }
      })
  }
}
